export const CLOSE_SMALL_MODAL = 'CLOSE_SMALL_MODAL';

const closeSmallModal = () => (
  (dispatch) => {
    dispatch({
      type: CLOSE_SMALL_MODAL,
    });
  }
);

export default closeSmallModal;
